export default __webpack_public_path__ + "static/media/swap-page.f8e6a8b6.png";